export const sanitizeFileNameVideo = (name: string) => {
  return name
    .replace(/\.[^/.]+$/, "")
    .replace(/[^A-Za-z0-9.]/g, "");
};
export const sanitizeFileNamePdf=(originalName: string): string=> {
    return originalName.replace(/[^a-zA-Z0-9.]/g, "");
}